import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, GuardsCheckStart, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {RendererService} from './_services/renderer.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  constructor(public rendererService: RendererService,
              private router: Router,
              private titleService: Title,
              private route: ActivatedRoute) {

  }

  ngOnInit(): void {
    // Au début du check par le guard, configure le service de rendu de l'interface
    this.router.events.pipe(
        filter(event => event instanceof GuardsCheckStart)
    ).subscribe((event: GuardsCheckStart) => {
       this.titleService.setTitle(this.route.root.snapshot.data['title']);
       this.rendererService.configure(event.url.split('/')[1]);
    });

    // A la fin de la navigation, récupère le title définit dans le router
    this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const title = this.route.root.firstChild.data['value'].title;
      if (title != null) { this.titleService.setTitle(this.route.root.firstChild.data['value'].title); }
    });
  }
}
